/* eslint-disable react/no-array-index-key */
import React from 'react';
import styles from './Message.module.css';

function useMessage(commands) {
  return ({
    eventHandlers: {

    },
    localStates: {

    },
  });
}

export default function Message(props) {
  const { commands, sharedStates } = props;
  const { localStates, eventHandlers } = useMessage(commands);

  return (
    <section className={styles.messageBox} >
      <p className={styles.message}>Pedido <span className={styles.orderId}>#{sharedStates.id}</span> realizado com {sharedStates.donation ? 'solidariedade' : 'sucesso'}!</p>


    </section>
  );
}
